import { Navigate } from 'react-router-dom';
import { useAgentSelector } from '../../auth/AgentSelectorContext';

/**
 * Redirects /app/plugins → /app/agents/:selectedAgentId/plugins
 * so the sidebar link works without hardcoding an agentId.
 */
export function PluginsRedirect() {
  const { selectedAgentId } = useAgentSelector();
  if (!selectedAgentId) return <Navigate to="/app/agents" replace />;
  return <Navigate to={`/app/agents/${selectedAgentId}/plugins`} replace />;
}
